/**
 * The icon tile appearance to use when rendering a Mercury Risk search result,
 * derived from the risk's status key.
 *
 * Shared between the Quick Find product entity renderer and the Full Page Search
 * Mercury Risk result renderer so the mapping stays in sync across surfaces.
 */
export const getRiskIconAppearance = (statusKey?: string): 'gray' | 'blue' | 'green' => {
	switch (statusKey?.toLowerCase()) {
		case 'accepted':
			return 'blue';
		case 'resolved':
			return 'green';
		default:
			return 'gray';
	}
};
